<template>
  <div class="container justify-content-center" px-1>
    <div class="sticky1">
      <h1 class="text-center">ЯГОДА</h1>
    </div>

    <input class="form-control" v-model="searchText" type="text" placeholder="Поиск"/>

    <div class="main-content">
      <div v-for="berry in berriesFiltered" :key="berry._id" class="mt-3">
        <div class="card">
          <div class="card-body">
            <div class="row fs-3 fw-bold">
              <div class="col-sm">{{ berry.label }}</div>
              <div class="col-sm">
                <button v-if="berry.edit" class="btn btn-light" @click="saveBerry(berry)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    viewBox="0 0 448 512"
                  >
                    <path
                      d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                    />
                  </svg>
                </button>

                <div v-if="berry.spinner" class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </div>

            <div class="row row-cols-1">
              <div class="col text-muted"><small>УСУШКА, %/кг</small></div>
              <div class="col">
                <input
                  class="form-control p-1"
                  v-model="berry.shrink"
                  type="number"
                  step="0.01"
                  @input="setBerryEdit(berry, true)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted, inject } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useCommonMixin from "@/components/commonMixin.js";

export default {
  name: "Berries",
  components: {},

  setup(props) {
    useCommonMixin();
    const { isAdmin, isWholesaler, asyncForEach } = useCommonMixin();
    const store = useStore();
    const router = useRouter();
    const berries = computed(() => store.getters.berry);
    const searchText = ref('')

    const saveBerry = async (berry) => {
      berry.spinner = true;
      let resp = await store.dispatch("POSTberry", berry);
      if (resp.status) {
        berry.spinner = false;
        setBerryEdit(berry, false);
      }
    };

    const setBerryEdit = (berry, value) => {
      berry.edit = value;
    };

    const berriesFiltered = computed(() => {
      let result = berries.value
      if(searchText.value) {
        result = berries.value.filter(item => item.label.toLowerCase().indexOf(searchText.value.toLowerCase()) >= 0)
      }
      return result
    })

    const init = async () => {
      await store.dispatch("FETCHberry");
    };

    onMounted(init);

    return {
      berries,
      isAdmin,
      saveBerry,
      setBerryEdit,
      searchText,
      berriesFiltered,
    };
  },
};
</script>

<style>
.price-head {
  /* transform: rotate(-45deg); */
  font-size: 0.8rem;
}
</style>
